const trainsKey = 'sdx-trains'
const getTrains = () => {
  return JSON.parse(window.localStorage.getItem(trainsKey))
}
const setTrains = trains => {
  return window.localStorage.setItem(trainsKey, JSON.stringify(trains))
}

const getUnPreloadedTrains = (trains, localTrains) => {
  localTrains = localTrains || []
  const newTrains = trains.map(train => {
    return {
      ...train,
      isPreLoaded: false,
      percentage: 0,
    }
  })
  newTrains.forEach(train => {
    localTrains.find(localTrain => {
      if (localTrain.trainId === train.trainId) {
        // 判断本地上次缓存的时间
        if (
          localTrain.date &&
          Date.now() - localTrain.date < 7 * 24 * 3600 * 1000
        ) {
          train.date = localTrain.date
          train.isPreLoaded = localTrain.isPreLoaded
          train.duration = localTrain.duration
        }
        return true
      }
    })
  })
  return newTrains
}

const preLoadIframe = (
  trains,
  status,
  iframe,
  { success = () => {}, timeout = 30, avgTime }
) => {
  const trainIndex = trains.findIndex(item => item.isPreLoaded === false)
  if (trainIndex === -1) {
    iframe.parentNode.removeChild(iframe)
    status.preLoading = false
    success({ trainIndex })
    return
  }
  console.log(trains[trainIndex].trainName, trainIndex)
  iframe.src = `${process.env.VUE_APP_TRAIN_PREFIX}${
    trains[trainIndex].trainPath
  }?mute=1`
  const startTime = Date.now()
  const failedTimer = window.setTimeout(() => {
    window.clearInterval(percentageTimer)
    window.removeEventListener('message', handleIframeLoad)
    trains[trainIndex].percentage = 100
    success({ trainIndex, trains, startTime })
    window.setTimeout(() => {
      trains[trainIndex].isPreLoaded = 'failed'
      trains[trainIndex].duration = Date.now() - startTime
      status.failed += 1
      setTrains(trains)
      console.log(Date.now() - startTime, '失败')
      preLoadIframe(trains, status, iframe, { success, timeout, avgTime })
    }, 1000)
  }, timeout * 1000)

  const percentageInterval = 0.5
  const percentageTimer = window.setInterval(() => {
    let piece
    const timeGrow = 1.2
    const stopPercentage = (1 / timeGrow) * 100
    if (trains[trainIndex].percentage < stopPercentage) {
      piece = (percentageInterval / (avgTime * timeGrow)) * 100
    } else {
      piece =
        (percentageInterval / (timeout - avgTime)) * (100 - stopPercentage)
    }
    trains[trainIndex].percentage = Number(
      (trains[trainIndex].percentage + piece).toFixed(2)
    )
    if (trains[trainIndex].percentage > 100) {
      trains[trainIndex].percentage = 100
    }
  }, percentageInterval * 1000)

  function handleIframeLoad(event) {
    if (event.data.action !== 'resourceOnload') return
    window.clearTimeout(failedTimer)
    window.clearInterval(percentageTimer)
    window.removeEventListener('message', handleIframeLoad)
    trains[trainIndex].percentage = 100
    success({ trainIndex, trains, startTime })
    // 给动画留时间
    window.setTimeout(() => {
      trains[trainIndex].isPreLoaded = true
      trains[trainIndex].date = Date.now()
      trains[trainIndex].duration = Date.now() - startTime
      status.preLoaded += 1
      setTrains(trains)
      console.log(Date.now() - startTime, '成功')
      preLoadIframe(trains, status, iframe, { success, timeout, avgTime })
    }, 1000)
  }

  window.addEventListener('message', handleIframeLoad, false)
}

const creatIframe = (id = 'preload') => {
  document.querySelectorAll(`iframe#${id}`).forEach(iframe => {
    iframe.parentNode.removeChild(iframe)
  })
  const iframe = document.createElement('iframe')
  iframe.id = id
  iframe.style.position = 'absolute'
  iframe.style.top = '0'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = '0'
  return iframe
}

export {
  getTrains,
  setTrains,
  getUnPreloadedTrains,
  preLoadIframe,
  creatIframe,
}
